// A link token is `base64url(grantId).base64url(HMAC-SHA256)` (LinkGrantToken.Create); the
// signature half is always 43 characters. A file on this origin (`/favicon.ico`, `/config.json`)
// can never take that shape, so it is never sent to Auth as a credential.
const LINK_TOKEN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]{16,}$/

export function parseLinkToken(segment: string | undefined | null): string | null {
  if (typeof segment !== 'string') return null
  return LINK_TOKEN.test(segment) ? segment : null
}
